// extracted by mini-css-extract-plugin
export var root = "modal-x-module--root--a7150";